import { render, staticRenderFns } from "./_.vue?vue&type=template&id=0366b158&scoped=true&"
import script from "./_.vue?vue&type=script&lang=js&"
export * from "./_.vue?vue&type=script&lang=js&"
import style0 from "./_.vue?vue&type=style&index=0&id=0366b158&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0366b158",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Filters: require('/var/www/k9-frontend/k9-front-20261006142511/components/filters/Filters.vue').default})
